module.exports = __webpack_public_path__ + "img/bg12.905c0861.png";